(ns ncr.fragment-types.attachments-editor
  (:require
   [clojure.string :as str]
   [cljs.core.async :as async :refer-macros [go] :refer [<!]]
   [uix.core.alpha :as uix]
   [ncr.common.ocr]
   [ncr.etc.util :as u]
   [ncr.widgets.core :as w]
   [ncr.widgets.dropzone :as wdz]
   [ncr.etc.pf :as pf]
   [ncr.push :as push]
   [ncr.widgets.datev]
   [ncr.manage.preferences :as preferences]
   [ncr.etc.pubsub :as ps]
   [ncr.etc.modal :as m]
   [ncr.etc.alert :as a]
   [ncr.etc.zip :as zip]
   [ncr.amplitude :as amp]
   [ncr.backend :as b]
   [ncr.fragment.attachments-backend :as ba]
   [ncr.fragment.attachment-label :as attachments]
   [ncr.fragment-types.attachments-editor-preview :as preview]
   [ncr.fragment.common :as c]
   [ncr.fragment-types.widgets :as ftw]
   [ncr.widgets.inline-edit :as inline-edit]
   [ncr.navigate :as n]))

(defn- !attachment-attach [fragment files]
  (go
    (let [progress (a/progress nil)]
      (<!
        (a/!operation* {:operation-title "Attach Files" :success-title "Files Attached"} progress
          (go
            (u/error-m
              [_
               (async/>! progress {:title "Uploading Files..."})

               attachments
               (<!
                 (->> files
                   (map ba/!upload*)
                   (async/merge)
                   (async/reduce conj [])))

               attachments
               (filter (complement u/m-fail?) attachments)

               _
               (async/>! progress {:title "Finalizing..."})

               _
               (when (seq attachments)
                 (<!
                   (b/!multi-mutation
                     (concat
                       (map
                         (fn [[attachment-id _]]
                           [(keyword (str "confirm_" attachment-id))
                            [:upload_confirm
                             {:id attachment-id}]])
                         attachments)

                       (map
                         (fn [[attachment-id file-name]]
                           [(keyword (str "attach_" attachment-id))
                            [:attachment_attach
                             {:reference (get fragment :id)
                              :attachment attachment-id
                              :fileName file-name}
                             [:id]]])
                         attachments)))))])))))))


(defn- !attachment-detach [reference-id attachments]
  (let
    [count (count attachments)
     single? (= count 1)
     single-file-name
     (when single?
       (-> attachments first :fileName))]

    (go
      (if
        (<!
          (m/!alert
            (if single?
              {:title "Delete File"
               :title-icon-variant :warning
               :actions-variant :ok-cancel
               :body
               [:span "Are you sure, you want to permanently delete file: "
                [:span.pf-u-font-weight-bold single-file-name] "?"]}
              {:title "Delete Files"
               :title-icon-variant :warning
               :actions-variant :ok-cancel
               :body
               [:span (u/format "Are you sure, you want to permanently delete %d files?" count)]})))
        (<!
          (a/!operation
            (if single?
              {:operation-title "Delete File" :success-title "File Permanently Deleted" :body single-file-name}
              {:operation-title "Delete Files" :success-title (u/format "%d Files Permanently Deleted" count)})
            (b/!multi-mutation
              (map
                (fn [{:keys [id]}]
                  [id
                   [:attachment_detach
                    {:reference reference-id
                     :attachment id}
                    [:id]]])
                attachments))))
        [:error :cancel]))))

(defn- set-preview
  ([fragment-id fragment-name id mime-type] (set-preview fragment-id fragment-name id mime-type nil))
  ([fragment-id fragment-name id mime-type on-complete]
   (go
     (let [url (async/<! (ba/!download-url fragment-id id :INLINE))]
       (when on-complete
         (on-complete))
       (n/replace-state! :fragment-slug-attachment
         {:id fragment-id
          :slug (c/fragment-name->slug fragment-name)
          :attachment-id id})
       (ps/pub! [::set-preview {:type mime-type :url url :id id}])))))

(defn c-attachment-card [{:keys [selected-files]} {reference-id :id :as fragment} {:keys [id fileName deleted mimeType] :as attachment}]
  (let
    [immutable (or (not (:writableHint fragment)) (:immutable attachment))
     attachment (assoc attachment :reference reference-id)
     fragment-name (:name fragment)
     open-preview
     (uix/callback
       (u/isolate*
         (fn [_]
           (when-not
             (let [r (js/window.getSelection)]
               (not (= 0 (- (.-anchorOffset r) (.-focusOffset r)))))
             (amp/navigate! {"Origin" "Fragment" "Destination" "Attachment"})
             (set-preview reference-id fragment-name id mimeType))))
       [fragment-name reference-id id mimeType])
     checked (contains? selected-files id)]

    (push/use-push!
      (fn [{:keys [domain domain-id]}]
        (when (and (= domain :attachment) (= domain-id id))
          (ps/pub! [:fragment/load false]))))

    [pf/c-card
     {:class :ncr-c-attachment-card
      :is-compact true
      :is-selected checked
      :is-selectable-raised true
      :is-flat false
      :on-click open-preview}

     [pf/c-card-header {:class :ncr-c-attachment-card__header :on-click open-preview}
      [attachments/c-attachment-icons {:icons #{:datev :textract :assist}} attachment]
      [pf/c-card-actions
       [pf/c-dropdown-menu
        [pf/c-menu {:is-plain true}
         [pf/c-menu-item
          {:icon [w/c-menu-icon {:icon :eye-outline}]
           :on-click open-preview}
          "View"]

         [pf/c-divider]

         [pf/c-menu-item
          {:icon [w/c-menu-icon {:icon :folder-eye-outline}]
           :on-click
           (fn [_]
             (ba/download! reference-id id :INLINE))}
          "Open in new tab"]

         [pf/c-menu-item
          {:icon [w/c-menu-icon {:icon :printer-outline}]
           :on-click
           (fn [_]
             (ba/print! reference-id id))}
          "Print"]

         [pf/c-menu-item
          {:icon [w/c-menu-icon {:icon :file-download-outline}]
           :on-click
           (fn [_]
             (ba/download! reference-id id :ATTACHMENT))}
          "Download"]

         [pf/c-divider]

         [pf/c-menu-item
          {:icon [w/c-menu-icon {:icon :repeat}]
           :is-disabled (not (ncr.common.ocr/mime-type-supported? mimeType))
           :on-click
           (fn [_]
             (ba/resubmit-for-ocr! reference-id id))}
          "Re-submit for OCR"]

         [pf/c-divider]

         [pf/c-menu-item
          {:icon [w/c-menu-icon {:icon :pencil-outline}]
           :is-disabled immutable
           :on-click
           (fn [_]
             (go
               (u/when-ok [_ (<! (ftw/!attachment-rename reference-id attachment fragment-name))]
                 (ps/pub! [:fragment/load false]))))}
          "Rename"]

         [pf/c-divider]

         (if-not deleted
           [pf/c-menu-item
            {:icon [w/c-menu-icon {:icon :delete-outline}]
             :is-disabled immutable
             :on-click
             (fn [_]
               (go
                 (u/when-ok [_ (<! (ftw/!attachment-set-deleted reference-id [attachment] true))]
                   (ps/pub! [:fragment/load false]))))}
            "Delete"]
           [:<>
            [pf/c-menu-item
             {:icon [w/c-menu-icon {:icon :file-restore-outline}]
              :is-disabled immutable
              :on-click
              (fn [_]
                (go
                  (u/when-ok [_ (<! (ftw/!attachment-set-deleted reference-id [attachment] false))]
                    (ps/pub! [:fragment/load false]))))}
             "Restore"]
            [pf/c-menu-item
             {:icon [w/c-menu-icon {:icon :delete-empty-outline}]
              :is-disabled immutable
              :on-click
              (fn [_]
                (go
                  (u/when-ok [_ (<! (!attachment-detach reference-id [attachment]))]
                    (ps/pub! [:fragment/load false]))))}
             "Delete Permanently..."]])]]

       [pf/c-checkbox-with-highlight
        {:id id
         :is-checked checked
         :on-change
         (fn [e]
           (.stopPropagation e)
           (ps/pub! [::set-attachment-checked (not checked) id]))}]]]

     [pf/c-card-footer
      {:class
       [:pf-u-ml-0 :ncr-c-attachment-card__name
        (when deleted :ncr-c-attachment-card__name-deleted)]}

      [inline-edit/c-inline-edit
       {:value fileName
        :hint
        (some-> (:name fragment)
          str/trim
          (str/replace #"[ ]{2,}" " ")
          (str/replace " " "_"))
        :read-only? immutable
        :on-click open-preview
        :on-pre-edit u/split-file-name
        :on-post-edit
        (fn [value ext]
          (str value ext))
        :on-edit-commit
        (fn [v s]
          (when-not (empty? v)
            (let [file-name (str v s)]
              (when-not (= file-name fileName)
                (go
                  (u/when-ok [_ (<! (ftw/!attachment-rename-operation reference-id (:id attachment) file-name))]
                    (ps/pub! [:fragment/load false])))))
            true))}]]]))

(defn- c-body [{:keys [dropzone]} {:keys [show-deleted?] :as state} {attachments :attachments writableHint :writableHint :as fragment}]
  (let
    [{:keys [get-root-props get-input-props is-drag-active open]} dropzone
     pointer-events
     {:style
      {:pointer-events
       (if is-drag-active
         :none :auto)}}]
    [pf/l-flex-item
     {:class [:pf-u-p-sm :ncr-fragment-attachments]}
     [:div
      (get-root-props)
      [:input (get-input-props)]
      [w/c-dropzone-target (not is-drag-active)]
      (let
        [attachments
         (->> attachments
           (filter
             (fn [{:keys [deleted]}]
               (or show-deleted?
                 (not deleted))))
           (sort-by :fileName))]

        (if-not (empty? attachments)
          [pf/c-list {:variant :inline :class [:ncr-c-attachment-cards-list :ncr-m-no-pointer-events]}
           (into [:<>]
             (for [attachment attachments]
               [pf/c-list-item
                (w/merge-props {:class :pf-u-mb-xl} pointer-events)
                [c-attachment-card state fragment attachment]]))]
          [pf/c-empty-state {:class :ncr-m-no-pointer-events}
           [pf/c-empty-state-icon
            {:variant :container :component [w/c-mdi-icon {:icon :feature-search-outline}]}]
           [pf/c-title {:heading-level :h4 :size :lg} "This fragment contains no attachments"]
           [pf/c-button
            (w/merge-props
              {:variant :primary
               :is-disabled (not writableHint)
               :icon
               [w/c-mdi-icon
                {:icon :file-plus-outline}]
               :on-click open}
              pointer-events)
            "Add File..."]]))]]))

(defn- c-toolbar [{:keys [open] :as props} {:keys [selected-files show-deleted?]}
                  {attachments :attachments reference-id :id writableHint :writableHint fragment-name :name}]
  [pf/l-flex-item (dissoc props :open :toggle-show-deleted)
   [pf/c-toolbar
    [pf/c-toolbar-content
     [pf/c-toolbar-group {:variant :icon-button-group :alignment {:default :align-right}}
      [pf/c-toolbar-item
       [w/c-toolbar-button
        {:icon :file-plus-outline
         :on-click open
         :tooltip "Add File..."}]]

      (let
        [selected?
         (comp selected-files :id)

         selected
         (filter selected? attachments)

         all-deletable
         (and
           writableHint
           (not-any? #(or (:deleted %) (:immutable %)) selected))

         all-undeleteable
         (and
           writableHint
           (every? #(and (:deleted %) (not (:immutable %))) selected))

         set-deleted
         (fn [fragments deleted]
           #(go
              (u/when-ok [_ (<! (ftw/!attachment-set-deleted reference-id fragments deleted))]
                (ps/pub! [::clear-selected-files])
                (ps/pub! [:fragment/load false]))))

         delete-permanently
         (fn [fragments]
           #(go
              (u/when-ok [_ (<! (!attachment-detach reference-id fragments))]
                (ps/pub! [:fragment/load false]))))]

        [:<>
         (when (seq selected-files)
           [:<>
            (when (preferences/use-experimental?)
              [w/c-toolbar-button
               {:icon :folder-zip-outline
                :experimental? true
                :on-click
                (fn [_]
                  (zip/download!
                    {:prefix (str (c/fragment-name->slug fragment-name) "_")
                     :attachments (map #(assoc % :fragment-id reference-id) selected)}))
                :tooltip "Download as zip"}])

            [pf/c-toolbar-item
             [w/c-toolbar-button
              {:icon :delete-outline
               :is-disabled (not all-deletable)
               :on-click (set-deleted selected true)}]]])

         [pf/c-toolbar-item
          [pf/c-dropdown-menu
           [pf/c-menu {:is-plain true}
            [pf/c-menu-item
             {:icon [w/c-menu-icon {:icon :file-plus-outline}]
              :is-disabled (not writableHint)
              :on-click open}
             "Add File..."]

            [pf/c-divider]

            (when-not (empty? selected-files)
              [:<>
               (when all-deletable
                 [pf/c-menu-item
                  {:icon [w/c-menu-icon {:icon :delete-outline}]
                   :is-disabled (not writableHint)
                   :on-click (set-deleted selected true)}
                  "Delete"])

               (when all-undeleteable
                 [:<>
                  [pf/c-menu-item
                   {:icon [w/c-menu-icon {:icon :file-restore-outline}]
                    :is-disabled (not writableHint)
                    :on-click (set-deleted selected false)}
                   "Restore"]

                  [pf/c-menu-item
                   {:icon [w/c-menu-icon {:icon :delete-empty-outline}]
                    :is-disabled (not writableHint)
                    :on-click (delete-permanently selected)}
                   "Delete Permanently..."]])

               (when (or all-deletable all-undeleteable)
                 [pf/c-divider])])

            [pf/c-menu-item
             {:icon [w/c-menu-icon {:icon :eye-outline}]
              :is-selected show-deleted?
              :on-click
              #(ps/pub! [::toggle-show-deleted])}
             "Show Deleted"]]]]])]]]])


(defn- c-files [{:keys [dropzone]} state fragment]
  (let [show-deleted (uix/state false)]
    [pf/l-flex {:class :pf-u-h-100 :direction :column}
     [c-toolbar
      {:open (get dropzone :open)
       :toggle-show-deleted
       (fn []
         (swap! show-deleted not))}
      state
      fragment]

     [c-body
      {:flex :flex-1
       :dropzone dropzone}
      state
      fragment]]))


(defn c-body* [_ {:keys [id attachments] :as fragment} attachment-id]
  (let
    [local-storage-key "attachment-editor-show-deleted"
     fragment-name (:name fragment)
     set-preview (partial set-preview id fragment-name)

     state
     @(ps/sub-reducer-map!
        {:selected-files #{}
         :preview nil

         :show-deleted?
         (if-some [show-deleted? (u/json-decode (js/localStorage.getItem local-storage-key))]
           show-deleted?
           false)}

        {::set-attachment-checked
         (fn [state is-selected? id]
           (update state :selected-files (if is-selected? conj disj) id))

         ::clear-attachment-checked
         (fn [state]
           (assoc state :selected-files #{}))

         ::toggle-show-deleted
         (fn [{:keys [show-deleted?] :as state}]
           (let [new-show-deleted? (not show-deleted?)]
             (js/localStorage.setItem local-storage-key new-show-deleted?)
             (assoc state :show-deleted? new-show-deleted?)))

         ::set-preview
         (fn [state data]
           (assoc state :preview data))

         ::close-preview
         (fn [state]
           (dissoc state :preview))})

     dropzone
     (wdz/use-dropzone
       {:no-click true
        :on-drop-accepted
        (fn [files]
          (go
            (u/when-ok [_ (<! (!attachment-attach fragment files))]
              (ps/pub! [:fragment/load false]))))})]

    (uix/with-effect [(get fragment :attachments) (get state :show-deleted?)]
      (ps/pub! [::clear-attachment-checked]))

    (uix/with-effect []
      (when-let [attachment (some #(when (= attachment-id (:id %)) %) attachments)]
        (set-preview attachment-id (:mimeType attachment))))

    (let
      [{:keys [preview show-deleted?]} state
       attachments (map #(assoc % :reference-id id) attachments)]
      (if-not (some? preview)
        [c-files {:dropzone dropzone} state fragment]
        [preview/c-viewer fragment-name preview
         (fn []
           (amp/navigate! {"Origin" "Attachment" "Destination" "Fragment"})
           (n/replace-state! :fragment-slug
             {:id id
              :slug (c/fragment-name->slug fragment-name)})
           (ps/pub! [::close-preview]))
         (if show-deleted? attachments (filter #(-> % :deleted not) attachments))
         (fn [& args]
           (amp/navigate! {"Origin" "Attachment" "Destination" "Attachment"})
           (apply set-preview args))]))))
